import { asSceneKey, type SceneKey } from '../sceneKeys.js';

export const WORLD_SCENE_KEY: SceneKey = asSceneKey('World');
